
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// export function insertFriendBusiness (parameter) {
//   return axios({
//     url: sysInfo.apiRemote + '/friendBusiness',
//     method: 'POST',
//     data: parameter
//   })
// }
export function updateFriendBusiness (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/friendBusiness',
    method: 'POST',
    data: parameter
  })
}
export function deleteFriendBusiness (ids) {
  return axios({
    url: sysInfo.apiRemote + '/friendBusiness?ids=' + ids,
    method: 'DELETE'
  })
}
export function getFriendBusinessList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/friendBusiness',
    method: 'GET',
    params: parameter
  })
}
// 禁用友商
export function disabledFriendBusiness (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/friendBusiness/disabled',
    method: 'POST',
    data: parameter
  })
}
// 启用友商
export function startUseFriendBusiness (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/friendBusiness/startUsing',
    method: 'POST',
    data: parameter
  })
}
// 历史投标
export function getHistoryBidding (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/historyList',
    method: 'GET',
    params: parameter
  })
}
